import { ApolloLink, HttpLink, NormalizedCacheObject } from '@apollo/client';
import { onError } from '@apollo/client/link/error';
import {
  ApolloClient,
  InMemoryCache,
  SSRMultipartLink,
} from '@apollo/client-integration-nextjs';
import possibleTypes from '@nerdwallet/apollo/possible-types';
import { getLogger } from '@nerdwallet/logging';
import { getCookie } from '../getCookie';

const logger = getLogger('landing-page-client apollo');

let apolloClient = null as unknown as ApolloClient<NormalizedCacheObject>;

/** Apollo Client for SSR and client components. */
const makeClient = (): ApolloClient<NormalizedCacheObject> => {
  const serverHttpLink = new HttpLink({
    uri: process.env.SUPERGRAPH_URL,
    credentials: 'include',
    headers: {
      'Content-type': 'application/json',
      'X-Application-ID': 'landing-page-client-next',
      'X-Caller-Client-ID': 'landing-page-client-next',
      'X-Client-Platform': 'server',
      'X-Client-Version': '0',
    },
  });
  apolloClient = new ApolloClient({
    cache: new InMemoryCache({
      possibleTypes: possibleTypes.possibleTypes,
    }),
    connectToDevTools: ['development', 'staging'].includes(
      process.env.DEPLOYABLE_ENV
    ),
    link:
      typeof window === 'undefined'
        ? ApolloLink.from([
            onError(({ graphQLErrors, networkError }) => {
              if (graphQLErrors) {
                graphQLErrors.map(({ message, locations, path }) =>
                  logger.log(
                    `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`
                  )
                );
              }
              logger.log(`[Network Error] ${networkError}`);
            }),
            new SSRMultipartLink({
              stripDefer: true,
            }),
            serverHttpLink,
          ])
        : ApolloLink.from([
            onError(({ graphQLErrors, networkError }) => {
              if (graphQLErrors) {
                graphQLErrors.map(({ message, locations, path }) =>
                  logger.log(
                    `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`
                  )
                );
              }
              logger.log(`[Network Error] ${networkError}`);
            }),
            new HttpLink({
              uri: process.env.BROWSER.SUPERGRAPH_URL,
              credentials: 'include',
              headers: {
                'Content-type': 'application/json',
                'X-Application-ID': 'landing-page-client-next',
                'X-Caller-Client-ID': 'landing-page-client-next',
                'X-Client-Platform': 'web',
                'X-Client-Version': '0',
                'x-originating-url': window.location.href,
                'X-Header-Csrf-Token': getCookie('csrf_token') as string,
              },
            }),
          ]),
  });

  return apolloClient;
};

export default makeClient;
